import React, { Component } from 'react';
import { connect } from 'react-redux';
import CostEstimateActions from 'agent_portal/actions/CostEstimateActions';
import * as PayersActions from 'shared/actions/PayersActions';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import Icon from 'shared/components/Icon';
import CostEstimateForm from './CostEstimateForm';

const formatCurrency = val => (val || val === 0 ? `$ ${val}` : '');

const CostEstimateDetail = ({ costEstimate }) => (
  <div className="CostEstimateDetails">
    <span className="fake-link" onClick={CostEstimateActions.resetCostEstimate}>
      {'<< New Cost Estimate'}
    </span>
    <Row>
      {costEstimate.warnings &&
        costEstimate.warnings.map(warning => (
          <div className="alert alert-warning">
            <Icon name="exclamation-triangle" /> Warning: {warning.message}
          </div>
        ))}
    </Row>
    <Row>
      <Widget span={6} title="Patient/Subscriber Info" icon="barcode" nopadding>
        <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <td>Subscriber Name:</td>
              <td>{`${costEstimate.demographics.subscriber.firstName} ${costEstimate.demographics.subscriber.lastName}`}</td>
            </tr>
            <tr>
              <td>Policy Number:</td>
              <td>{costEstimate.demographics.subscriber.memberId}</td>
            </tr>
            <tr>
              <td>Group Number:</td>
              <td>{costEstimate.demographics.subscriber.groupId}</td>
            </tr>
            {costEstimate.demographics.subscriber.groupName && (
              <tr>
                <td>Group Name:</td>
                <td>{costEstimate.demographics.subscriber.groupName}</td>
              </tr>
            )}
            <tr>
              <td>Coverage Status:</td>
              <td>{costEstimate.plan.coverageStatusLabel}</td>
            </tr>
            <tr>
              <td>Insurance Company:</td>
              <td>{costEstimate.insurance.name}</td>
            </tr>
            <tr>
              <td>Plan:</td>
              <td>{costEstimate.plan.planTypeLabel}</td>
            </tr>
            <tr>
              <td>Plan Begin ("YYYY-MM-DD"):</td>
              <td>
                {costEstimate.plan.dates.filter(d => d.dateType === 'plan_begin')[0].dateValue}
              </td>
            </tr>
            <tr>
              <td>Plan End ("YYYY-MM-DD"):</td>
              <td>{costEstimate.plan.dates.filter(d => d.dateType === 'plan_end')[0].dateValue}</td>
            </tr>
          </tbody>
        </table>
      </Widget>

      <Widget span={6} title="Cost Estimate" icon="barcode" nopadding>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>Network</td>
              <td>
                {costEstimate.costEstimates[0].network === 'IN' ? 'In Network' : 'Out of Network'}
              </td>
            </tr>
            <tr>
              <td>Co-Pay:</td>
              <td>
                {formatCurrency(
                  costEstimate.costEstimates[0].costEstimateEquation.appliedAmounts.copayment.amount
                )}
              </td>
            </tr>
            <tr>
              <td>Towards Deductible:</td>
              <td>
                {formatCurrency(
                  costEstimate.costEstimates[0].costEstimateEquation.appliedAmounts.deductible
                    .amount
                )}
              </td>
            </tr>
            <tr>
              <td>
                Co-Insurance: (
                {
                  costEstimate.costEstimates[0].costEstimateEquation.appliedAmounts.coinsurance
                    .percent
                }
                %)
              </td>
              <td>
                {formatCurrency(
                  costEstimate.costEstimates[0].costEstimateEquation.appliedAmounts.coinsurance
                    .amount
                )}
              </td>
            </tr>
            <tr style={{ borderTop: '2px solid #333', backgroundColor: 'rgb(224, 251, 248)' }}>
              <td>
                <b>Total:</b>
              </td>
              <td>{formatCurrency(costEstimate.costEstimates[0].costEstimate)}</td>
            </tr>
          </tbody>
        </table>
      </Widget>

      <Widget span={6} title="Coverage Details" icon="barcode" nopadding>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th />
              <th>In Network</th>
              <th>Out of Network</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Deductible:</td>
              <td>
                <ul>
                  {costEstimate.plan.financials.deductible.totals.inNetwork.map(d => (
                    <li>
                      <b>{d.level}:</b> {formatCurrency(d.amount)}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {costEstimate.plan.financials.deductible.totals.outNetwork.map(d => (
                    <li>
                      <b>{d.level}:</b> {formatCurrency(d.amount)}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
            <tr>
              <td>Deductible Met:</td>
              <td>
                <ul>
                  {costEstimate.plan.financials.deductible.totals.inNetwork.map((d, i) => (
                    <li>
                      <b>{d.level}:</b>{' '}
                      {formatCurrency(
                        d.amount -
                          costEstimate.plan.financials.deductible.remainings.inNetwork[i].amount
                      )}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {costEstimate.plan.financials.deductible.totals.outNetwork.map((d, i) => (
                    <li>
                      <b>{d.level}:</b>{' '}
                      {formatCurrency(
                        d.amount -
                          costEstimate.plan.financials.deductible.remainings.outNetwork[i].amount
                      )}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
            <tr>
              <td>Out of Pocket Max:</td>
              <td>
                <ul>
                  {costEstimate.plan.financials.stopLoss.totals.inNetwork.map(sl => (
                    <li>
                      <b>{sl.level}:</b> {formatCurrency(sl.amount)}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {costEstimate.plan.financials.stopLoss.totals.outNetwork.map(sl => (
                    <li>
                      <b>{sl.level}:</b> {formatCurrency(sl.amount)}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
            <tr>
              <td>Out of Pocket Met:</td>
              <td>
                <ul>
                  {costEstimate.plan.financials.stopLoss.totals.inNetwork.map((sl, i) => (
                    <li>
                      <b>{sl.level}:</b>{' '}
                      {formatCurrency(
                        sl.amount -
                          costEstimate.plan.financials.stopLoss.remainings.inNetwork[i].amount
                      )}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {costEstimate.plan.financials.stopLoss.totals.outNetwork.map((sl, i) => (
                    <li>
                      <b>{sl.level}:</b>{' '}
                      {formatCurrency(
                        sl.amount -
                          costEstimate.plan.financials.stopLoss.remainings.outNetwork[i].amount
                      )}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
            <tr>
              <td>Co-Pay:</td>
              <td>
                <ul>
                  {costEstimate.plan.financials.copayment.amounts.inNetwork.map(copay => (
                    <li>
                      <b>{copay.level}:</b> {formatCurrency(copay.amount)}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {costEstimate.plan.financials.copayment.amounts.outNetwork.map(copay => (
                    <li>
                      <b>{copay.level}:</b> {formatCurrency(copay.amount)}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
            <tr>
              <td>Co-Insurance:</td>
              <td>
                <ul>
                  {costEstimate.plan.financials.coinsurance.percents.inNetwork.map(ci => (
                    <li>
                      <b>{ci.level}:</b> {ci.amount}%
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                <ul>
                  {costEstimate.plan.financials.coinsurance.percents.outNetwork.map(ci => (
                    <li>
                      <b>{ci.level}:</b> {ci.amount}%
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </Widget>
    </Row>
  </div>
);

class CostEstimatesPage extends Component {
  componentDidMount() {
    this.props.dispatch(PayersActions.payersRequested());
  }

  render() {
    const { costEstimate, payers } = this.props;

    return (
      <Page title="Cost Estimates">
        {costEstimate ? (
          <CostEstimateDetail costEstimate={costEstimate} />
        ) : (
          <Row>
            <Widget span={12} title="New Cost Estimate" icon="barcode" nopadding>
              <CostEstimateForm payers={payers} />
            </Widget>
          </Row>
        )}
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    costEstimate: state.costEstimate.costEstimate,
    payers: state.payers.items,
  };
}

export default connect(mapStateToProps)(CostEstimatesPage);
